export default __webpack_public_path__ + "static/appdynamics-mini-cloud-679aade0608f2eb0649cfee657df8554.png";